export default __webpack_public_path__ + "static/media/saarland_dark.43dc854f.png";